import React from 'react';
import { Link } from 'react-router-dom';
import AppsLayout from './AppsLayout';
import { PolicyArticle, PolicyContents } from './components/PolicyContent';
import Button from './components/Button';
import terms from '../../content/birdify/terms.json';
import provenance from '../../content/birdify/terms-source.json';
import { trackClick } from '../../firebase/analytics';
import { APPS_ROUTES, SITE_ORIGIN } from './routes';

const PAGE = 'apps_birdify_terms';

/**
 * Birdify terms of service rendered from the checked-in snapshot
 * (src/content/birdify/terms.json, provenance in terms-source.json).
 * Layout, typography, dark mode, print styles, skip link and anchors are shared
 * with the privacy policy. No animation is applied to the text.
 */
export default function BirdifyTermsPage() {
  return (
    <AppsLayout
      theme="canopy"
      title="Birdify terms of service · Keval Langalia"
      description="The terms of service for the Birdify Android app: free educational use, on-device identification results, your responsibilities, third-party content, warranties and liability."
      canonicalPath={APPS_ROUTES.birdifyTerms}
      breadcrumbs={[
        { label: 'Portfolio', to: APPS_ROUTES.apps, id: 'apps' },
        { label: 'Birdify', to: APPS_ROUTES.birdify, id: 'birdify' },
        { label: 'Terms of service' },
      ]}
      page={PAGE}
      support={false}
    >
      <header className="apps-section" style={{ marginTop: 0 }}>
        <p className="apps-eyebrow">{terms.app} · Terms</p>
        <h1 className="apps-title">{terms.title}</h1>
        <dl className="apps-policy-meta">
          <div>
            <dt>Operator</dt>
            <dd>{terms.operator}</dd>
          </div>
          <div>
            <dt>Effective date</dt>
            <dd>{terms.effectiveDate.text}</dd>
          </div>
          <div>
            <dt>Contact</dt>
            <dd>
              <a href={`mailto:${terms.contact.email}`} onClick={trackClick(PAGE, 'header_contact_email_link')}>{terms.contact.label}</a>
            </dd>
          </div>
        </dl>
      </header>

      <div className="apps-policy">
        <PolicyContents policy={terms} label="Terms contents" />

        <div>
          <PolicyArticle policy={terms} label="Birdify terms of service" localOrigin={SITE_ORIGIN}>
            <p className="apps-muted" style={{ marginTop: '2rem', fontSize: '0.9rem' }}>
              Terms text imported from the Birdify repository ({provenance.sourcePath} at commit {provenance.sourceCommit.slice(0, 12)}). Only the document layout differs from the source.
            </p>
          </PolicyArticle>

          <div className="apps-hero-actions" style={{ marginTop: '2rem' }}>
            <Button to={APPS_ROUTES.birdify} variant="secondary" onClick={trackClick(PAGE, 'back_to_birdify_button')}>
              Back to Birdify
            </Button>
            <Button to={APPS_ROUTES.birdifyPrivacy} variant="secondary" onClick={trackClick(PAGE, 'privacy_policy_button')}>
              Read the privacy policy
            </Button>
            <Link to={APPS_ROUTES.apps} className="kds-btn kds-btn--text" onClick={trackClick(PAGE, 'all_apps_link')}>
              All projects
            </Link>
          </div>
        </div>
      </div>
    </AppsLayout>
  );
}
